import { buildAvatarStyle } from './map-congregacion-row';
import { capitalizeWords, formatNombreCompletoDisplay } from './nombre-texto.helper';
import { UserProfile } from '../interfaces/user.interface';

export function formatDisplayName(user: Pick<UserProfile, 'nombre' | 'nombre2' | 'apellido'>): string {
  return formatNombreCompletoDisplay(user.nombre, user.nombre2, user.apellido);
}

/** Primera letra de cada palabra. El mail no pasa por acá. */
export function formatTextoPropio(value?: string | null): string {
  return capitalizeWords(value);
}

/** YYYY-MM-DD or ISO → dd/MM/yyyy local. */
export function formatFechaNacimiento(nacimiento?: string | null): string {
  if (!nacimiento) {
    return 'Dato vacio.';
  }
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(nacimiento.trim());
  if (m) {
    return `${m[3]}/${m[2]}/${m[1]}`;
  }
  const d = new Date(nacimiento);
  if (Number.isNaN(d.getTime())) {
    return 'Dato vacio.';
  }
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export function emptyOr(value: string | null | undefined, fallback = 'Dato vacio.'): string {
  if (value == null || String(value).trim() === '') {
    return fallback;
  }
  return String(value);
}

export function whatsappHref(prefijo?: string | null, celular?: string | null, nombre?: string): string | null {
  if (!celular) {
    return null;
  }
  const digits = `${prefijo ?? ''}${celular}`.replace(/\D/g, '');
  if (!digits) {
    return null;
  }
  const text = encodeURIComponent(`Hola ${nombre ?? ''}, `);
  return `https://wa.me/${digits}?text=${text}`;
}

export function mapsHref(direccion?: string | null, ciudad?: string | null): string | null {
  if (!direccion || !direccion.trim()) {
    return null;
  }
  const q = encodeURIComponent([direccion, ciudad].filter(Boolean).join(','));
  return `https://www.google.com/maps/place/${q}`;
}

export function perfilAvatarStyle(sexo?: string | null): Record<string, string> {
  return {
    ...buildAvatarStyle(sexo),
    width: '6rem',
    height: '6rem',
    fontSize: '2rem',
  };
}

export function perfilInitials(user: Pick<UserProfile, 'nombre' | 'apellido'>): string {
  const a = (user.nombre ?? '').trim().charAt(0);
  const b = (user.apellido ?? '').trim().charAt(0);
  return `${a}${b}`.toUpperCase() || '?';
}